import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function HistoriasSucessoHoobuy() {
  return <ArticleLayout article={newArticles[8]} />;
}